// extracted by mini-css-extract-plugin
module.exports = {"container":"S01_Intro_container__2Lq0O","box":"S01_Intro_box__3VI46","en":"S01_Intro_en__2P1TA","sub":"S01_Intro_sub__3H6oD"};